import { catchError } from 'rxjs/operators';
import { Exception } from './Exception';
import { HttpException } from './HttpException';
export const exceptionHandler = (err, fallbackMsg = 'An error has occurred') => {
  if (Object.getPrototypeOf(err.constructor).name == 'Exception') throw err;
  switch (typeof err) {
    case typeof Exception:
    case typeof HttpException:
      throw err;
    default:
      throw new Error(fallbackMsg);
  }
};
export const pipeExceptionHandler = (fallbackMsg = 'An error has occurred') => catchError(err => {
  switch (typeof err) {
    case typeof Exception:
    case typeof HttpException:
      throw err;
    default:
      throw new Error(fallbackMsg);
  }
});
